import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { captureRef } from "../lib/ref";
import { PebbleMark } from "../components/Logo";

export default function ReferralCapture() {
  const { code } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    captureRef(code);
    navigate("/", { replace: true });
  }, [code, navigate]);

  return (
    <div className="min-h-screen bg-cream flex items-center justify-center" data-testid="referral-capture">
      <div className="animate-pulse flex flex-col items-center gap-3">
        <PebbleMark size={48} />
        <p className="text-soft font-serif italic">Welcome to Pebble Farms…</p>
      </div>
    </div>
  );
}
